// @flow

const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
const GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR';
const CHECK_IS_DARK = 'CHECK_IS_DARK';
export type AppTypes =
  | 'CHECK_IS_DARK'
  | 'GET_PROJECTS_REQUEST'
  | 'GET_PROJECTS_SUCCESS'
  | 'GET_PROJECTS_ERROR';

export default {
  GET_PROJECTS_REQUEST,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_ERROR,
  CHECK_IS_DARK,
};



// WEBPACK FOOTER //
// ./src/view/duck/types.js